import { render, staticRenderFns } from "./ThirdConfigInfo.vue?vue&type=template&id=4881c3a8"
import script from "./ThirdConfigInfo.vue?vue&type=script&lang=js"
export * from "./ThirdConfigInfo.vue?vue&type=script&lang=js"
import style0 from "./ThirdConfigInfo.vue?vue&type=style&index=0&id=4881c3a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports